<template>
  <div class="files-requests-tab task-details-tabbed__scroll-body" data-testid="files-requests-tab">
    <TaskFilesSection
      :task="task"
      :capabilities="capabilities"
      data-testid="files-requests-tab__files"
      @open-upload="$emit('open-upload')"
      @refresh="$emit('refresh')"
    />
    <TaskInfoRequestsSection
      :task="task"
      :metadata="metadata"
      :inforeqstage="inforeqstage"
      data-testid="files-requests-tab__requests"
      @approve="$emit('approve', $event)"
      @reject="$emit('reject', $event)"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<script>
import TaskFilesSection from './TaskFilesSection.vue';
import TaskInfoRequestsSection from './TaskInfoRequestsSection.vue';

export default {
  name: 'FilesRequestsTab',

  components: {
    TaskFilesSection,
    TaskInfoRequestsSection,
  },

  props: {
    task: { type: Object, required: true },
    fileNamesList: { type: Array, default: () => [] },
    capabilities: { type: Object, default: () => ({}) },
    viewtaskdata: { type: Object, default: () => ({}) },
    metadata: { type: Object, default: () => ({}) },
    inforeqstage: { type: Number, default: 0 },
  },
};
</script>

<style lang="scss" scoped>
.files-requests-tab {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}
</style>
